//import Carousel from 'bootstrap/js/dist/carousel';

// Components
import { isbot } from "isbot";
//import isAdmin from "../components/is-admin";
import NotificationBanner from "../components/notification-banner";
import RevealElements from "../components/reveal-elements";
import RevealStatistics from "../components/reveal-statistics";
import SearchBar from "../components/search-bar";
import NewsletterWidget from "../components/widget-newsletter";
import NavMenu from "../components/nav-menu";
import NavMenuMobileSlideOver from "../components/nav-menu-mobile-slide-over";
import ResponsiveSwiper from '../components/responsive-swiper';
import videoPlayback from '../components/video';
import gridCarousel from '../components/grid';
import testimonialSlider from '../components/testimonials';
import footerLogoAnimation from '../components/footer';
import galleryCarousel from '../components/gallery';
import googleMap from '../components/map';
import tooltipFunction from '../components/tooltips';
//import debounce from "../util/debounce";

export default {
    init() {
        document.documentElement.classList.remove("no-js");

        requestAnimationFrame(() => {
            setTimeout(() => {
                document.documentElement.classList.add("js");
            }, 0)
        });

        if (isbot(navigator.userAgent) === true) {
            requestAnimationFrame(() => {
                setTimeout(() => {
                    document.documentElement.classList.add("is-bot");
                }, 0)
            });
        }

        // Only enable focus outlines after Tab key is pressed (accessibility)
        document.body.addEventListener("keyup", function (event) {
            if (event.key === "Tab") {
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        document.documentElement.classList.remove("no-focus-outline")
                    }, 0);
                });
            }
        });

        // set initial vh
        // let vh = window.innerHeight * 0.01;
        // document.documentElement.style.setProperty('--vh', `${vh}px`);

        // let vw = window.innerWidth * 0.01;
        // document.documentElement.style.setProperty('--vw', `${vw}px`);

        // let isXxlBreakpoint = window.matchMedia("only screen and (min-width: 1400px)").matches;
        // let isXlBreakpoint = window.matchMedia("only screen and (min-width: 1200px)").matches;
        // let isLgBreakpoint = window.matchMedia("only screen and (min-width: 992px)").matches;
        // let isMdBreakpoint = window.matchMedia("only screen and (min-width: 768px)").matches;
        // let isSmBreakpoint = window.matchMedia("only screen and (min-width: 576px)").matches;
        // let isMobileBreakpoint = window.matchMedia("only screen and (max-width: 1199.98px)").matches;

        // resize handler
        // function handleResize()
        // {
        //     // re-calculate vh
        //     vh = window.innerHeight * 0.01;
        //     document.documentElement.style.setProperty('--vh', `${vh}px`);

        //     vw = window.innerWidth * 0.01;
        //     document.documentElement.style.setProperty('--vw', `${vw}px`);

        //     isXxlBreakpoint = window.matchMedia("only screen and (min-width: 1400px)").matches;
        //     isXlBreakpoint = window.matchMedia("only screen and (min-width: 1200px)").matches;
        //     isLgBreakpoint = window.matchMedia("only screen and (min-width: 992px)").matches;
        //     isMdBreakpoint = window.matchMedia("only screen and (min-width: 768px)").matches;
        //     isSmBreakpoint = window.matchMedia("only screen and (min-width: 576px)").matches;
        //     isMobileBreakpoint = window.matchMedia("only screen and (max-width: 1199.98px)").matches;
        // }

        // window.addEventListener('resize', debounce(handleResize, 16));

        new NavMenu(); // new menu
    },

    finalize() {
        new NotificationBanner();
        new RevealElements();
        new RevealStatistics();
        new SearchBar();
        new NewsletterWidget();
        new videoPlayback();
        new gridCarousel();
        new testimonialSlider();
        new footerLogoAnimation();
        new galleryCarousel();
        new googleMap();
        new tooltipFunction();

        if (bf_opts.config.submenu_style) {
            switch (bf_opts.config.submenu_style) {
                case 'slide-over':
                    new NavMenuMobileSlideOver();
                    break;
            }
        }

        const responsiveSwiperElements = document.querySelectorAll(".swiper");
        if (responsiveSwiperElements.length) {
            responsiveSwiperElements.forEach(element => {
                new ResponsiveSwiper(element);
            })
        }

        //if (isbot(navigator.userAgent) !== true) {
        // Search auto complete
        // if (searchInput !== null) {
        //     const autocompleteSearch = new SearchAutoComplete(searchInput);
        //     // submit form when enter key is pressed (if no autocomplete selection)
        //     searchInput.addEventListener('keydown', event => {
        //         if (autocompleteSearch.getSelection() === null) {
        //             if (event.code === 'Enter') {
        //                 //event.preventDefault();
        //                 requestAnimationFrame(() => {
        //                     setTimeout(() => {
        //                         searchInput.closest('form').submit()
        //                     }, 0);
        //                 });
        //             }
        //         }
        //     });
        // }

        // if (searchInputMobile !== null) {
        //     new SearchAutoComplete(searchInputMobile);
        // }

        // Make Gravity Forms placeholders in select elements non-selectable
        // if (gfPlaceholders.length > 0) {
        //     gfPlaceholders.forEach(element => {
        //         element.setAttribute('disabled', '');
        //     });
        // }

        // if (typeof jQuery !== "undefined") {
        //     const gforms = document.querySelectorAll('.gform_wrapper');
        //     if (gforms.length) {
        // Scroll to top of Gravity form after submission
        // jQuery(document).on('gform_confirmation_loaded', function(event, form_id) {
        //     const form = document.getElementById('gform_confirmation_wrapper_' + form_id);
        //     if (form !== null) {
        //         let formTop = getElementTop(form);
        //         if (formTop !== false) {
        //             requestAnimationFrame(() => {
        //                 setTimeout(() => {
        //                     window.scrollTo({
        //                         top: formTop,
        //                         behavior: 'smooth'
        //                     });
        //                 }, 0);
        //             });
        //         }
        //     }
        // });

        // Add .is-loading class to Gravity forms when they are submitted (for styling submit button)
        // document.addEventListener('click', event => {
        //     if (event.target.classList.contains('gform-btn') || event.target.closest('.gform-btn')) {
        //         const form = event.target.closest('form');
        //         if (!form.classList.contains('is-loading')) {
        //             requestAnimationFrame(() => {
        //                 setTimeout(() => {
        //                     form.classList.add('is-loading')
        //                 }, 0);
        //             });
        //         }
        //     }
        // })
        //     }
        // }
        //}
    }
};
